"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarsFilterAdmin = void 0;
var react_1 = __importDefault(require("react"));
var customFetch_1 = require("../helpers/customFetch");
var INIT_FILTER_VALUE = {
    brand_name: 'Все бренды',
    model_name: 'Все модели',
    generation_name: 'Все поколения',
};
var createFilterUrl = function (params, changedKey) {
    var searchParams = new URLSearchParams();
    var filterOrder = ['brand_name', 'model_name', 'generation_name'];
    var currentKeyIndex = filterOrder.indexOf(changedKey);
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        var keyIndex = filterOrder.indexOf(key);
        if (value && value !== INIT_FILTER_VALUE[key] && keyIndex <= currentKeyIndex) {
            searchParams.append(key, value);
        }
    });
    var queryString = searchParams.toString();
    return queryString ? "?".concat(queryString) : '';
};
var useCarsFilterAdmin = function () {
    var _a = react_1.default.useState([]), cars = _a[0], setCars = _a[1];
    var _b = react_1.default.useState(true), loading = _b[0], setLoading = _b[1];
    var _c = react_1.default.useState({
        brand_name: {
            key: 'brand_name',
            selectItems: [],
            value: INIT_FILTER_VALUE.brand_name,
        },
        model_name: {
            key: 'model_name',
            selectItems: [],
            value: INIT_FILTER_VALUE.model_name,
        },
        generation_name: {
            key: 'generation_name',
            selectItems: [],
            value: INIT_FILTER_VALUE.generation_name,
        },
    }), filters = _c[0], setFilters = _c[1];
    var fetchData = function (urlSuffix) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, filterData, carsData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.all([
                            (0, customFetch_1.customFetch)({ url: "filters".concat(urlSuffix), method: 'GET' }),
                            (0, customFetch_1.customFetch)({
                                url: "cars".concat(urlSuffix ? "".concat(urlSuffix, "&coll=all") : ''),
                                method: 'GET',
                            }),
                        ])];
                case 2:
                    _a = _b.sent(), filterData = _a[0], carsData = _a[1];
                    return [2 /*return*/, { filterData: filterData, carsData: carsData }];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateFilters = function (key, value, selectItemsUpdate) {
        setFilters(function (prev) {
            var newFilters = __assign({}, prev);
            newFilters[key] = __assign(__assign({}, newFilters[key]), { value: value });
            var resetOrder = ['brand_name', 'model_name', 'generation_name'];
            var currentIndex = resetOrder.indexOf(key);
            resetOrder.slice(currentIndex + 1).forEach(function (filterKey) {
                newFilters[filterKey] = __assign(__assign({}, newFilters[filterKey]), { value: INIT_FILTER_VALUE[filterKey] });
            });
            selectItemsUpdate === null || selectItemsUpdate === void 0 ? void 0 : selectItemsUpdate.forEach(function (update) {
                newFilters[update.key] = __assign(__assign({}, newFilters[update.key]), { selectItems: update.values });
            });
            return newFilters;
        });
    };
    var handleFilterChange = function (key, value) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFilters, urlSuffix, _a, filterData, carsData, updates;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    currentFilters = (_b = {
                            brand_name: filters.brand_name.value,
                            model_name: filters.model_name.value,
                            generation_name: filters.generation_name.value
                        },
                        _b[key] = value,
                        _b);
                    urlSuffix = createFilterUrl(currentFilters, key);
                    return [4 /*yield*/, fetchData(urlSuffix)];
                case 1:
                    _a = _c.sent(), filterData = _a.filterData, carsData = _a.carsData;
                    setCars(carsData);
                    updates = [];
                    if (key === 'brand_name') {
                        updates.push({ key: 'model_name', values: filterData[2].values });
                    }
                    else if (key === 'model_name') {
                        updates.push({ key: 'generation_name', values: filterData[3].values });
                    }
                    updateFilters(key, value, updates);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.default.useEffect(function () {
        var initializeFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
            var filterData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchData('')];
                    case 1:
                        filterData = (_a.sent()).filterData;
                        updateFilters('brand_name', INIT_FILTER_VALUE.brand_name, [
                            { key: 'brand_name', values: filterData[1].values },
                        ]);
                        return [2 /*return*/];
                }
            });
        }); };
        initializeFilters();
    }, []);
    return {
        cars: cars,
        loading: loading,
        filters: filters,
        onFilterChange: handleFilterChange,
        setCars: setCars,
    };
};
exports.useCarsFilterAdmin = useCarsFilterAdmin;
